import { Dispatch, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { AnyAction } from '@reduxjs/toolkit'
import { Button } from 'primereact/button'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFinalPuzzleRequest } from '../../../redux/actions/gameActions'
import { useNavigate, useParams } from 'react-router-dom'
import { getGameSelector } from '../../../redux/selectors/gameSelectors'
import { GameState } from '../../../redux/types/game'
import { decodeIframeString } from '../../../utils/decodeIframeString'
import Loading from '../../../components/Loading'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import * as DOMPurify from 'dompurify'
import jwt_decode from 'jwt-decode'
import { Map } from 'iconsax-react'
import useSound from 'use-sound'
import { useTranslation } from 'react-i18next'

const FinalPuzzle = () => {
  const { localeId } = useParams()
  const {
    data: { finalPuzzle, volumeGlobal, branding },
    loading: gameLoading,
  }: GameState = useSelector(getGameSelector)

  const dispatch: Dispatch<AnyAction> = useDispatch()
  const navigate = useNavigate()
  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })
  const { t } = useTranslation()

  const token = localStorage.getItem('tokenCityHunt') ?? ''

  const { GameType }: any = jwt_decode(token)

  useEffect(() => {
    dispatch(fetchFinalPuzzleRequest(localeId))
  }, [])

  const sanitizedData = (data: string) => ({
    __html: DOMPurify.sanitize(data, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['src', 'class', 'allowfullscreen', 'frameborder'],
    }),
  })

  Sentry.setContext('Variables', {
    localeId,
    GameType,
  })

  if (gameLoading.isLoadingFinalPuzzle) {
    return <Loading />
  }

  return (
    <>
      <div
        className="flex flex-wrap justify-content-between"
        id="game-puzzle"
        style={{ width: '100%' }}
        // style={{ height: '100vh', width: '100%' }}
      >
        <div className="p-3" style={{ height: '100%', width: '100%' }}>
          <div
            style={{ overflowWrap: 'break-word' }}
            className="img-full-width ql-editor"
            dangerouslySetInnerHTML={sanitizedData(
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              decodeIframeString(finalPuzzle?.finalHtml ?? '') ?? '',
            )}
          />
          <div
            style={{ width: '100%' }}
            className="flex justify-content-center"
          >
            <Button
              label={
                GameType !== 'Indoor' ? t('BackToMap') : t('BackToMainScreen')
              }
              onClick={() => {
                clickSound()
                navigate('/game')
              }}
              type="button"
              // icon={<Map color="#fff" variant="Bold" className="mr-1" />}
              icon={
                GameType !== 'Indoor' ? (
                  <>
                    <div
                      className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                      style={{
                        backgroundColor: branding?.buttonPrimary.textColor,
                      }}
                    >
                      {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                    </div>
                    <Map
                      color={branding?.buttonPrimary.backgroundColor}
                      variant="Bold"
                      className="icon-center"
                      // className="p-button-icon p-c p-button-icon-right"
                    />
                  </>
                ) : undefined
              }
              className="p-button-rounded mt-5 p-button-raised  w-full"
              style={{
                backgroundColor: branding?.buttonPrimary.backgroundColor,
                color: branding?.buttonPrimary.textColor,
              }}
              // className="p-button-rounded mt-5 p-button-raised  w-full sign-in-btn"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default FinalPuzzle
